import { HYPHEN, MINUS } from './consts';

// Apply this only at the end of formatting. Funcs before are unaware of the MINUS
export function replaceHyphen(formattedValue: string) {
  return formattedValue.startsWith(HYPHEN)
    ? `${MINUS}${formattedValue.substring(1)}`
    : formattedValue;
}
